const Facebook = () => {
   return (
      <svg width="48" height="48" viewBox="0 0 48 48" fill="none"
         xmlns="http://www.w3.org/2000/svg">
         <path
            d="M20.5 44.7667C10.5833 43.0167 3 34.3833 3 24C3 12.45 12.45 3 24 3C35.55 3 45 12.45 45 24C45 34.3833 37.4167 43.0167 27.5 44.7667L26.3333 43.8333H21.6667L20.5 44.7667Z"
            fill="url(#paint0_linear_2650_62880)"></path>
         <path
            d="M32.1667 29.8334L33.1 24H27.5V19.9167C27.5 18.2834 28.0833 17 30.65 17H33.3333V11.6334C31.8167 11.4 30.1833 11.1667 28.6667 11.1667C23.8833 11.1667 20.5 14.0834 20.5 19.3334V24H15.25V29.8334H20.5V44.65C21.6667 44.8834 22.8333 45 24 45C25.1667 45 26.3333 44.8834 27.5 44.65V29.8334H32.1667Z"
            fill="white"></path>
         <defs>
            <linearGradient id="paint0_linear_2650_62880" x1="24"
               y1="43.5463" x2="24" y2="3"
               gradientUnits="userSpaceOnUse">
               <stop stopColor="#0062E0"></stop>
               <stop offset="1" stopColor="#19AFFF"></stop>
            </linearGradient>
         </defs>
      </svg>
   )
}
export default Facebook